import { FormFieldText } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  FormFieldText,
  React
};